import axios from "axios";
import { marvinHost } from "../utils/config";
import { redirectToLogin } from "../utils/browserUtils";
import { getMarvinToken, getRegionID } from "../utils/authUtils";
import { isMiP } from "../utils/helpers";
import { attachPayloadCrypto } from "./payloadCrypto";
// Function to get the authorization token
const axiosInstanceMarvin = axios.create({
  baseURL: marvinHost,
  headers: {
    Accept: "*/*",
    "Content-Type": "application/json",
    "User-Agent": false,
  },
});

// The JWT is kept in memory only. Persisting it in sessionStorage let a previous
// tenant's token survive a tenant switch in the same tab. Purge legacy entries.
sessionStorage.removeItem("casa-authorization-token");

// Payload encryption (FSP-5412). marvinHost is a path on the serving origin on the custom-domain
// deployment, where appgateway seals /api/v1/Marvin.svc/** on the same route table as the
// FieldSales APIs. Registered before the response interceptor below for the same reason as in
// axiosInstance.js, and a no-op everywhere else.
attachPayloadCrypto(axiosInstanceMarvin);

if (isMiP()) {
  axiosInstanceMarvin.defaults.withCredentials = true;
} else if (getMarvinToken() && getRegionID()) {
  axiosInstanceMarvin.defaults.headers.common["x-lsq-marvin-token"] = getMarvinToken();
  axiosInstanceMarvin.defaults.headers.common["x-lsq-regionId"] = getRegionID();
} 

// Add a request interceptor to capture the start time  
axiosInstanceMarvin.interceptors.request.use(config => {  
  config.startTime = performance.now(); // Record the start time  
  return config;
}); 

axiosInstanceMarvin.interceptors.response.use(
  (response) => {
    const endTime = performance.now(); // Record the end time  
    const duration = endTime - response.config.startTime; 
    response.responseTime = duration;
    if (response.headers?.authorization) {
      axiosInstanceMarvin.defaults.headers.common["authorization"] =
        response.headers.authorization;
    }
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      redirectToLogin();
    }
    return Promise.reject(error);
  }
);

export default axiosInstanceMarvin;
